function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_286_"
}, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_284_",
  fill: "#231F20",
  cx: 161.706,
  cy: -7.765,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_283_",
  fill: "#231F20",
  cx: 161.706,
  cy: 20.512,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_282_",
  fill: "#231F20",
  cx: 161.706,
  cy: 48.788,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_281_",
  fill: "#231F20",
  cx: 161.706,
  cy: 77.064,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_280_",
  fill: "#231F20",
  cx: 161.706,
  cy: 105.341,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_279_",
  fill: "#231F20",
  cx: 161.706,
  cy: 133.617,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_278_",
  fill: "#231F20",
  cx: 161.706,
  cy: 161.893,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_277_",
  fill: "#231F20",
  cx: 161.706,
  cy: 190.169,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_276_",
  fill: "#231F20",
  cx: 161.706,
  cy: 218.445,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_275_",
  fill: "#231F20",
  cx: 161.706,
  cy: 246.722,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_274_",
  fill: "#231F20",
  cx: 161.706,
  cy: 274.999,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_273_",
  fill: "#231F20",
  cx: 161.706,
  cy: 303.274,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_272_",
  fill: "#231F20",
  cx: 161.706,
  cy: 331.551,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_271_",
  fill: "#231F20",
  cx: 161.706,
  cy: 359.828,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_270_",
  fill: "#231F20",
  cx: 161.706,
  cy: 388.104,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_269_",
  fill: "#231F20",
  cx: 161.706,
  cy: 416.38,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_268_",
  fill: "#231F20",
  cx: 161.706,
  cy: 444.656,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_267_",
  fill: "#231F20",
  cx: 161.706,
  cy: 472.933,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_266_",
  fill: "#231F20",
  cx: 161.706,
  cy: 501.209,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_265_",
  fill: "#231F20",
  cx: 161.706,
  cy: 529.484,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_264_",
  fill: "#231F20",
  cx: 161.706,
  cy: 557.762,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_263_",
  fill: "#231F20",
  cx: 161.706,
  cy: 586.037,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_262_",
  fill: "#231F20",
  cx: 161.706,
  cy: 614.313,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_261_",
  fill: "#231F20",
  cx: 161.706,
  cy: 642.59,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_260_",
  fill: "#231F20",
  cx: 161.706,
  cy: 670.865,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_259_",
  fill: "#231F20",
  cx: 161.706,
  cy: 699.141,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_258_",
  fill: "#231F20",
  cx: 161.706,
  cy: 727.418,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_257_",
  fill: "#231F20",
  cx: 161.706,
  cy: 755.695,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_244_",
  fill: "#231F20",
  cx: 133.43,
  cy: -7.765,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_243_",
  fill: "#231F20",
  cx: 133.43,
  cy: 20.512,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_242_",
  fill: "#231F20",
  cx: 133.43,
  cy: 48.788,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_241_",
  fill: "#231F20",
  cx: 133.43,
  cy: 77.064,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_240_",
  fill: "#231F20",
  cx: 133.43,
  cy: 105.341,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_239_",
  fill: "#231F20",
  cx: 133.43,
  cy: 133.617,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_238_",
  fill: "#231F20",
  cx: 133.43,
  cy: 161.893,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_237_",
  fill: "#231F20",
  cx: 133.43,
  cy: 190.169,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_236_",
  fill: "#231F20",
  cx: 133.43,
  cy: 218.445,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_235_",
  fill: "#231F20",
  cx: 133.43,
  cy: 246.722,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_234_",
  fill: "#231F20",
  cx: 133.43,
  cy: 274.999,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_233_",
  fill: "#231F20",
  cx: 133.43,
  cy: 303.274,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_232_",
  fill: "#231F20",
  cx: 133.43,
  cy: 331.551,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_231_",
  fill: "#231F20",
  cx: 133.43,
  cy: 359.828,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_230_",
  fill: "#231F20",
  cx: 133.43,
  cy: 388.104,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_229_",
  fill: "#231F20",
  cx: 133.43,
  cy: 416.38,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_228_",
  fill: "#231F20",
  cx: 133.43,
  cy: 444.656,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_227_",
  fill: "#231F20",
  cx: 133.43,
  cy: 472.933,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_226_",
  fill: "#231F20",
  cx: 133.43,
  cy: 501.209,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_225_",
  fill: "#231F20",
  cx: 133.43,
  cy: 529.484,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_224_",
  fill: "#231F20",
  cx: 133.43,
  cy: 557.762,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_223_",
  fill: "#231F20",
  cx: 133.43,
  cy: 586.037,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_222_",
  fill: "#231F20",
  cx: 133.43,
  cy: 614.313,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_221_",
  fill: "#231F20",
  cx: 133.43,
  cy: 642.59,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_220_",
  fill: "#231F20",
  cx: 133.43,
  cy: 670.865,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_219_",
  fill: "#231F20",
  cx: 133.43,
  cy: 699.141,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_218_",
  fill: "#231F20",
  cx: 133.43,
  cy: 727.418,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_217_",
  fill: "#231F20",
  cx: 133.43,
  cy: 755.695,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_204_",
  fill: "#231F20",
  cx: 105.154,
  cy: -7.765,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_203_",
  fill: "#231F20",
  cx: 105.154,
  cy: 20.512,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_202_",
  fill: "#231F20",
  cx: 105.154,
  cy: 48.788,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_201_",
  fill: "#231F20",
  cx: 105.154,
  cy: 77.064,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_200_",
  fill: "#231F20",
  cx: 105.154,
  cy: 105.341,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_199_",
  fill: "#231F20",
  cx: 105.154,
  cy: 133.617,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_198_",
  fill: "#231F20",
  cx: 105.154,
  cy: 161.893,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_197_",
  fill: "#231F20",
  cx: 105.154,
  cy: 190.169,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_196_",
  fill: "#231F20",
  cx: 105.154,
  cy: 218.445,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_195_",
  fill: "#231F20",
  cx: 105.154,
  cy: 246.722,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_194_",
  fill: "#231F20",
  cx: 105.154,
  cy: 274.999,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_193_",
  fill: "#231F20",
  cx: 105.154,
  cy: 303.274,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_192_",
  fill: "#231F20",
  cx: 105.154,
  cy: 331.551,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_191_",
  fill: "#231F20",
  cx: 105.154,
  cy: 359.828,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_190_",
  fill: "#231F20",
  cx: 105.154,
  cy: 388.104,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_189_",
  fill: "#231F20",
  cx: 105.154,
  cy: 416.38,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_188_",
  fill: "#231F20",
  cx: 105.153,
  cy: 444.656,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_187_",
  fill: "#231F20",
  cx: 105.153,
  cy: 472.933,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_186_",
  fill: "#231F20",
  cx: 105.153,
  cy: 501.209,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_185_",
  fill: "#231F20",
  cx: 105.153,
  cy: 529.484,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_184_",
  fill: "#231F20",
  cx: 105.153,
  cy: 557.762,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_183_",
  fill: "#231F20",
  cx: 105.153,
  cy: 586.037,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_182_",
  fill: "#231F20",
  cx: 105.153,
  cy: 614.313,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_181_",
  fill: "#231F20",
  cx: 105.153,
  cy: 642.59,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_180_",
  fill: "#231F20",
  cx: 105.153,
  cy: 670.865,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_179_",
  fill: "#231F20",
  cx: 105.153,
  cy: 699.141,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_178_",
  fill: "#231F20",
  cx: 105.153,
  cy: 727.418,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_177_",
  fill: "#231F20",
  cx: 105.153,
  cy: 755.695,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_164_",
  fill: "#231F20",
  cx: 76.877,
  cy: -7.765,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_163_",
  fill: "#231F20",
  cx: 76.877,
  cy: 20.512,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_162_",
  fill: "#231F20",
  cx: 76.877,
  cy: 48.788,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_161_",
  fill: "#231F20",
  cx: 76.877,
  cy: 77.064,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_160_",
  fill: "#231F20",
  cx: 76.877,
  cy: 105.341,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_159_",
  fill: "#231F20",
  cx: 76.877,
  cy: 133.617,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_158_",
  fill: "#231F20",
  cx: 76.877,
  cy: 161.893,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_157_",
  fill: "#231F20",
  cx: 76.877,
  cy: 190.169,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_156_",
  fill: "#231F20",
  cx: 76.877,
  cy: 218.445,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_155_",
  fill: "#231F20",
  cx: 76.877,
  cy: 246.722,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_154_",
  fill: "#231F20",
  cx: 76.877,
  cy: 274.999,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_153_",
  fill: "#231F20",
  cx: 76.877,
  cy: 303.274,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_152_",
  fill: "#231F20",
  cx: 76.877,
  cy: 331.551,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_151_",
  fill: "#231F20",
  cx: 76.877,
  cy: 359.828,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_150_",
  fill: "#231F20",
  cx: 76.877,
  cy: 388.104,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_149_",
  fill: "#231F20",
  cx: 76.877,
  cy: 416.38,
  r: 4.156
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_148_",
  fill: "#231F20",
  cx: 76.877,
  cy: 444.656,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_147_",
  fill: "#231F20",
  cx: 76.877,
  cy: 472.933,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_146_",
  fill: "#231F20",
  cx: 76.877,
  cy: 501.209,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_145_",
  fill: "#231F20",
  cx: 76.877,
  cy: 529.484,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_144_",
  fill: "#231F20",
  cx: 76.877,
  cy: 557.762,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_143_",
  fill: "#231F20",
  cx: 76.877,
  cy: 586.037,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_142_",
  fill: "#231F20",
  cx: 76.877,
  cy: 614.313,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_141_",
  fill: "#231F20",
  cx: 76.877,
  cy: 642.59,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_140_",
  fill: "#231F20",
  cx: 76.877,
  cy: 670.865,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_139_",
  fill: "#231F20",
  cx: 76.877,
  cy: 699.141,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_138_",
  fill: "#231F20",
  cx: 76.877,
  cy: 727.418,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_137_",
  fill: "#231F20",
  cx: 76.877,
  cy: 755.695,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_124_",
  fill: "#231F20",
  cx: 48.602,
  cy: -7.765,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_123_",
  fill: "#231F20",
  cx: 48.602,
  cy: 20.512,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_122_",
  fill: "#231F20",
  cx: 48.602,
  cy: 48.788,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_121_",
  fill: "#231F20",
  cx: 48.602,
  cy: 77.064,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_120_",
  fill: "#231F20",
  cx: 48.602,
  cy: 105.341,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_119_",
  fill: "#231F20",
  cx: 48.602,
  cy: 133.617,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_118_",
  fill: "#231F20",
  cx: 48.602,
  cy: 161.893,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_117_",
  fill: "#231F20",
  cx: 48.602,
  cy: 190.169,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_116_",
  fill: "#231F20",
  cx: 48.602,
  cy: 218.445,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_115_",
  fill: "#231F20",
  cx: 48.602,
  cy: 246.722,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_114_",
  fill: "#231F20",
  cx: 48.602,
  cy: 274.999,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_113_",
  fill: "#231F20",
  cx: 48.602,
  cy: 303.274,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_112_",
  fill: "#231F20",
  cx: 48.602,
  cy: 331.551,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_111_",
  fill: "#231F20",
  cx: 48.602,
  cy: 359.828,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_110_",
  fill: "#231F20",
  cx: 48.602,
  cy: 388.104,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_109_",
  fill: "#231F20",
  cx: 48.602,
  cy: 416.38,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_108_",
  fill: "#231F20",
  cx: 48.602,
  cy: 444.656,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_107_",
  fill: "#231F20",
  cx: 48.602,
  cy: 472.933,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_106_",
  fill: "#231F20",
  cx: 48.602,
  cy: 501.209,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_105_",
  fill: "#231F20",
  cx: 48.602,
  cy: 529.484,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_104_",
  fill: "#231F20",
  cx: 48.602,
  cy: 557.762,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_103_",
  fill: "#231F20",
  cx: 48.602,
  cy: 586.037,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_102_",
  fill: "#231F20",
  cx: 48.602,
  cy: 614.313,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_101_",
  fill: "#231F20",
  cx: 48.602,
  cy: 642.59,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_100_",
  fill: "#231F20",
  cx: 48.602,
  cy: 670.865,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_99_",
  fill: "#231F20",
  cx: 48.602,
  cy: 699.141,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_98_",
  fill: "#231F20",
  cx: 48.602,
  cy: 727.418,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_97_",
  fill: "#231F20",
  cx: 48.602,
  cy: 755.695,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_84_",
  fill: "#231F20",
  cx: 20.324,
  cy: -7.765,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_83_",
  fill: "#231F20",
  cx: 20.324,
  cy: 20.512,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_82_",
  fill: "#231F20",
  cx: 20.324,
  cy: 48.788,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_81_",
  fill: "#231F20",
  cx: 20.324,
  cy: 77.064,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_80_",
  fill: "#231F20",
  cx: 20.324,
  cy: 105.341,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_79_",
  fill: "#231F20",
  cx: 20.324,
  cy: 133.617,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_78_",
  fill: "#231F20",
  cx: 20.324,
  cy: 161.893,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_77_",
  fill: "#231F20",
  cx: 20.324,
  cy: 190.169,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_76_",
  fill: "#231F20",
  cx: 20.324,
  cy: 218.445,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_75_",
  fill: "#231F20",
  cx: 20.324,
  cy: 246.722,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_74_",
  fill: "#231F20",
  cx: 20.324,
  cy: 274.999,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_73_",
  fill: "#231F20",
  cx: 20.324,
  cy: 303.274,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_72_",
  fill: "#231F20",
  cx: 20.324,
  cy: 331.551,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_71_",
  fill: "#231F20",
  cx: 20.324,
  cy: 359.828,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_70_",
  fill: "#231F20",
  cx: 20.324,
  cy: 388.104,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_69_",
  fill: "#231F20",
  cx: 20.324,
  cy: 416.379,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_68_",
  fill: "#231F20",
  cx: 20.324,
  cy: 444.656,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_67_",
  fill: "#231F20",
  cx: 20.324,
  cy: 472.932,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_66_",
  fill: "#231F20",
  cx: 20.324,
  cy: 501.209,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_65_",
  fill: "#231F20",
  cx: 20.324,
  cy: 529.484,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_64_",
  fill: "#231F20",
  cx: 20.324,
  cy: 557.762,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_63_",
  fill: "#231F20",
  cx: 20.324,
  cy: 586.037,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_62_",
  fill: "#231F20",
  cx: 20.324,
  cy: 614.313,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_61_",
  fill: "#231F20",
  cx: 20.324,
  cy: 642.59,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_60_",
  fill: "#231F20",
  cx: 20.324,
  cy: 670.865,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_59_",
  fill: "#231F20",
  cx: 20.324,
  cy: 699.141,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_58_",
  fill: "#231F20",
  cx: 20.324,
  cy: 727.418,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_57_",
  fill: "#231F20",
  cx: 20.324,
  cy: 755.695,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_44_",
  fill: "#231F20",
  cx: -7.951,
  cy: -7.765,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_43_",
  fill: "#231F20",
  cx: -7.951,
  cy: 20.512,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_42_",
  fill: "#231F20",
  cx: -7.951,
  cy: 48.788,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_41_",
  fill: "#231F20",
  cx: -7.951,
  cy: 77.064,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_40_",
  fill: "#231F20",
  cx: -7.951,
  cy: 105.341,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_39_",
  fill: "#231F20",
  cx: -7.951,
  cy: 133.617,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_38_",
  fill: "#231F20",
  cx: -7.951,
  cy: 161.893,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_37_",
  fill: "#231F20",
  cx: -7.951,
  cy: 190.169,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_36_",
  fill: "#231F20",
  cx: -7.951,
  cy: 218.445,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_35_",
  fill: "#231F20",
  cx: -7.951,
  cy: 246.722,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_34_",
  fill: "#231F20",
  cx: -7.951,
  cy: 274.999,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_33_",
  fill: "#231F20",
  cx: -7.951,
  cy: 303.274,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_32_",
  fill: "#231F20",
  cx: -7.951,
  cy: 331.551,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_31_",
  fill: "#231F20",
  cx: -7.951,
  cy: 359.828,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_30_",
  fill: "#231F20",
  cx: -7.951,
  cy: 388.104,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_29_",
  fill: "#231F20",
  cx: -7.951,
  cy: 416.379,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_28_",
  fill: "#231F20",
  cx: -7.951,
  cy: 444.656,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_27_",
  fill: "#231F20",
  cx: -7.951,
  cy: 472.932,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_26_",
  fill: "#231F20",
  cx: -7.951,
  cy: 501.209,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_25_",
  fill: "#231F20",
  cx: -7.951,
  cy: 529.484,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_24_",
  fill: "#231F20",
  cx: -7.951,
  cy: 557.762,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_23_",
  fill: "#231F20",
  cx: -7.951,
  cy: 586.037,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_22_",
  fill: "#231F20",
  cx: -7.951,
  cy: 614.313,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_21_",
  fill: "#231F20",
  cx: -7.951,
  cy: 642.59,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_20_",
  fill: "#231F20",
  cx: -7.951,
  cy: 670.865,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_19_",
  fill: "#231F20",
  cx: -7.951,
  cy: 699.141,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_18_",
  fill: "#231F20",
  cx: -7.951,
  cy: 727.418,
  r: 4.155
}), /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_17_",
  fill: "#231F20",
  cx: -7.951,
  cy: 755.695,
  r: 4.155
}));

function SvgKatakanaProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135px",
    height: "765px",
    viewBox: "0 0 135 765",
    enableBackground: "new 0 0 135 765",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatakanaProfile);
export default __webpack_public_path__ + "static/media/katakana-profile.ecd0f23c.svg";
export { ForwardRef as ReactComponent };